<template>
  <md-toolbar
    md-elevation="0"
    class="md-transparent"
    :class="{
      'md-toolbar-absolute md-white md-fixed-top': $route.meta.navbarAbsolute
    }"
  >
    <div class="md-toolbar-row">
      <div class="md-toolbar-section-start">
        <h3 class="md-title">{{getRouteName($route.name)}}</h3>
      </div>
      <div class="md-toolbar-section-end">
        <md-button
          class="md-just-icon md-round md-simple md-toolbar-toggle"
          :class="{ toggled: $sidebar.showSidebar }"
          @click="toggleSidebar"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>

        <div class="md-collapse">
          <md-list>
            <!-- WebSocket status idicator -->
            <md-list-item
              :title="[wsConnected ? $lang.general.ws_icon_connected : $lang.general.ws_icon_not_connected]"
            >
              <md-icon style="margin: 0px;">{{wsConnected ? 'cloud_queue' : 'cloud_off'}}</md-icon>
            </md-list-item>

            <li class="md-list-item">
              <!-- <div class="md-list-item-content"> -->

              <!-- </div> -->
            </li>
          </md-list>
        </div>
      </div>
    </div>
    <snack-bar ref="snackbar"></snack-bar>
  </md-toolbar>
</template>

<script>
import snackBar from "@/components/SnackBar";

export default {
  components: {
    snackBar
  },
  data() {
    return {
      offlineCounter: 0
    };
  },

  computed: {
    wsConnected() {
      return this.$store.getters.isConnected;
    }
  },

  watch: {
    wsConnected(newVal, oldVal) {
      if (newVal) {
        if (this.offlineCounter > 0) {
          this.offlineCounter = 0;
          this.$refs.snackbar.notify("You are online");
        }
      } else {
        this.offlineCounter++;
        this.$refs.snackbar.notify("You are currently offline");
      }
    }
  },

  methods: {
    getRouteName(routeName) {
      return this.$lang.titles[routeName];
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
